import React, { useState } from "react";
import Header from "../components/Header";
import Leftpanel from "../components/Leftpanel";
import { Outlet } from "react-router-dom";

const Mainpage = ({ adminPanel, setAdminPanel }) => {
  const [leftOpen, setLeftOpen] = useState(true);
  const [selected, setSelected] = useState("");

  return (
    <div className="h-full w-full flex flex-col">
      <div className="w-full flex flex-col items-center sticky top-0 z-10 bg-white z-20">
        <Header setAdmin={setAdminPanel} admin={adminPanel} />
      </div>
      <div className="flex w-full">
        <div
          className={`transform-all duration-300 sticky left-0 top-24 ${
            leftOpen ? "w-[30%] max-w-[320px]" : "w-[8%]"
          } border-r-[1px] border-commonborder h-full relative`}
        >
          <Leftpanel
            leftOpen={leftOpen}
            admin={adminPanel}
            setAdmin={setAdminPanel}
          />
          <button
            onClick={() => setLeftOpen(!leftOpen)}
            className="absolute -right-4 top-10"
          >
            <img
              className={`transform transition-transform duration-300 ${
                leftOpen ? "rotate-[0deg]" : "rotate-[180deg]"
              }`}
              src={process.env.PUBLIC_URL + "/images/toggleleft.svg"}
              alt="hide/show panel"
            />
          </button>
        </div>
        <div className={`${leftOpen ? "w-full" : "w-[92%]"} h-full}`}>
          <Outlet context={setSelected} />
        </div>
      </div>
    </div>
  );
};

export default Mainpage;
